export default "__VITE_ASSET__C_In0RyT__"